import React, { useEffect, useState } from 'react';
import Uppy from '@uppy/core';
import { DragDrop, StatusBar } from '@uppy/react';
import XHR from '@uppy/xhr-upload';

import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

import { useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";

import ConfirmModal from '../_modals/ConfirmModal';
import '../_modals/modalStyle.css'

import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';

import { API_URL } from '../../config/constants';
import { randomUid } from '../../utils/utils';

const DUPLICATE_QUESTIONS_REGEX = /^questions with ids \{(.+)\} already exist in question bank/

const buildEndpoint = (endpoint, forceUpdate) => {
    if(!forceUpdate)
        return API_URL + endpoint
    const separator = endpoint.includes('?') ? '&' : '?'
    return API_URL + endpoint + separator + 'force_update=true'
}

export default function QuestionsUploader (props) {

    const t = useSelector(selectTranslations)
    const currentLang = useSelector(selectCurrentLang)

    const [duplicateQuestions, setDuplicateQuestions] = useState({ show: false, count: 0 })

    const [uppy] = useState(() => new Uppy({id:randomUid(), debug: true, autoProceed:true, locale:currentLang})
            .use(XHR, {
                endpoint: buildEndpoint(props.endpoint, false),
                withCredentials: true,
                getResponseError (responseText, response) {
                    const error = JSON.parse(responseText)
                    const duplicateMatch = typeof error.detail === 'string' && error.detail.match(DUPLICATE_QUESTIONS_REGEX)
                    if(duplicateMatch){
                        const ids = [...duplicateMatch[1].matchAll(/'([^']*)'/g)]
                        setDuplicateQuestions({ show: true, count: ids.length })
                    } else {
                        toast.error(error.detail)
                    }
                    return new Error(error.detail)
                },
                getResponseData (responseText) {
                    uppy.getPlugin('XHRUpload').setOptions({ endpoint: buildEndpoint(props.endpoint, false) })
                    toast.success(props.successMessage || t.question.import_success)
                    props.onUploadComplete?.()
                }
            }));

    const handleConfirmForceUpdate = () => {
        uppy.getPlugin('XHRUpload').setOptions({ endpoint: buildEndpoint(props.endpoint, true) })
        setDuplicateQuestions({ show: false, count: 0 })
        uppy.retryAll()
    }

    const handleCancelForceUpdate = () => {
        setDuplicateQuestions({ show: false, count: 0 })
    }

    return (
        <>
        <Modal
            show={props.show}
            onHide={props.onClose}
            centered
        >
            <Modal.Body>
                <h3 className='mb-2'>{props.title || t.question.excel_import}</h3>
                {props.description && <p className='small'>{props.description}</p>}
                <DragDrop uppy={uppy} />
                <StatusBar hideAfterFinish={true} uppy={uppy} />
            </Modal.Body>
        </Modal>
        <ConfirmModal props={{
            show: duplicateQuestions.show,
            title: t.question.duplicate_questions_title,
            text: t.question.duplicate_questions_text.replace('{count}', duplicateQuestions.count),
            onConfirm: handleConfirmForceUpdate,
            onClose: handleCancelForceUpdate,
            confirmCta: t.question.duplicate_questions_confirm,
            closeCta: t.modals.abort
        }} />
        </>

    )
}